module.exports = __webpack_public_path__ + "static/media/_DSC1610.e36679e5.jpg";